@if (!link.permissions || link.permissions.includes(user.level)) {
  <a
    [className]="active && link.route !== '/' ? 'active': 'not-active'"
    [routerLink]="[link.route]"
    (click)="closeNav.emit()"
    >
    <li>{{ link.text }} <i class="{{ link.icon }}"></i></li>
  </a>
}
